export default "__VITE_ASSET__BGg2Gm$Y__"